import {IBannerData} from "./IBannerData";

export class BannerDataIframe implements IBannerData {
    id: string;

    constructor(id: string) {
        this.id = id;
    }
}
